export default __webpack_public_path__ + "tmp_src/components/QuantitySelector/QuantitySelector~aurora.css.liquid";